import axios from 'axios';
import { store } from 'src/store';

import { getLocalStorage, StorageKey } from '../utils/localStorages';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const apiInstance = axios.create({
  baseURL: BASE_URL,
});

apiInstance.interceptors.request.use((requestConfig) => {
  const guestIdFromLS = getLocalStorage(StorageKey.UserId);
  const guestIdFromStore = store.getState().guestId;

  const guestAuthId = guestIdFromLS || guestIdFromStore;
  requestConfig.headers['Guest-Authorization'] = `Bearer ${guestAuthId}`;

  return requestConfig;
});
